module.exports = __webpack_public_path__ + "static/media/leasBackgroundPic.d32e7e0f.jpg";